import { GetRowIdParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useCallback } from "react";
import type { SawQualityCheck } from "../../repositories/sawWriteRepository";
import { useTableData } from "./hooks/useTableData";

interface Props {
	rows: SawQualityCheck[];
	loading: boolean;
	onReclassify: (check: SawQualityCheck) => void;
	onEdit: (check: SawQualityCheck) => void;
	onDelete: (check: SawQualityCheck) => void;
}

export const LastSawChecksTable = ({
	rows,
	loading,
	onReclassify,
	onEdit,
	onDelete,
}: Props) => {
	const { columnDefs } = useTableData({ onReclassify, onEdit, onDelete });

	const getRowId = useCallback(
		(params: GetRowIdParams<SawQualityCheck>) =>
			String(params.data.QualityCheckId),
		[],
	);

	return (
		<div
			style={{
				height: "100%",
				width: "100%",
				border: "1px solid #ccc",
				borderRadius: "4px",
			}}
		>
			<AgGridReact<SawQualityCheck>
				rowData={rows}
				columnDefs={columnDefs}
				loading={loading}
				suppressContextMenu
				tooltipShowDelay={300}
				headerHeight={35}
				rowHeight={46}
				getRowId={getRowId}
				overlayNoRowsTemplate="<span></span>"
			/>
		</div>
	);
};
